import { Auth0Provider } from '@auth0/auth0-react';
import { GoogleOAuthProvider } from '@react-oauth/google';
import type { ReactNode } from 'react';

type AuthProviderProps = {
  children: ReactNode;
};

const getRequiredAuthEnvValue = (
  envName: string,
  value: string | undefined,
) => {
  if (!value) {
    throw new Error(`Missing required auth environment variable: ${envName}`);
  }

  return value;
};

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const auth0Domain = getRequiredAuthEnvValue(
    'VITE_PUBLIC_AUTH0_DOMAIN',
    import.meta.env.VITE_PUBLIC_AUTH0_DOMAIN,
  );
  const auth0ClientId = getRequiredAuthEnvValue(
    'VITE_PUBLIC_AUTH0_CLIENT_ID',
    import.meta.env.VITE_PUBLIC_AUTH0_CLIENT_ID,
  );
  const googleClientId = getRequiredAuthEnvValue(
    'VITE_PUBLIC_GOOGLE_AUTH_CLIENT_ID',
    import.meta.env.VITE_PUBLIC_GOOGLE_AUTH_CLIENT_ID,
  );

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{ redirect_uri: `${window.location.origin}/login` }}
    >
      <GoogleOAuthProvider clientId={googleClientId}>
        {children}
      </GoogleOAuthProvider>
    </Auth0Provider>
  );
};
